module.exports = __webpack_public_path__ + "static/img/Kaitlin-Torpey.c672864.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kaitlin-Torpey.jpg
// module id = 8eIh
// module chunks = 0